import DashboardProfile from "./DashbordProfile";
export default DashboardProfile;
